import { tpePaymentMethodLabels } from "cadendar-shared";
import type { TpePaymentMethod } from "cadendar-shared";

const methodOrder = ["sansContact", "insertion", "amex"] as const;

export function TpePaymentMethodButtons({
  value,
  suggestedValue,
  onValueChange,
  disabled,
  ariaLabel,
}: {
  value: TpePaymentMethod | null;
  suggestedValue?: TpePaymentMethod | null;
  onValueChange: (value: TpePaymentMethod) => void;
  disabled?: boolean;
  ariaLabel?: string;
}) {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className="flex gap-1"
    >
      {methodOrder.map((method) => {
        const selected = method === value;
        const suggested = !value && method === suggestedValue;
        return (
          <button
            key={method}
            type="button"
            onClick={() => onValueChange(method)}
            disabled={disabled}
            aria-pressed={selected}
            className={`rounded border px-2 py-1 text-sm font-medium disabled:opacity-50 ${
              selected
                ? "border-emerald-700 bg-emerald-600 text-white"
                : suggested
                  ? "animate-pulse border-amber-500 bg-amber-50 text-amber-900 ring-2 ring-amber-300"
                  : "border-slate-300 bg-white text-slate-700 hover:bg-slate-50"
            }`}
          >
            {tpePaymentMethodLabels[method]}
          </button>
        );
      })}
    </div>
  );
}
